module.exports = __webpack_public_path__ + "static/cellerMinifundi-ac5bd2877bae5fffe6ec236dfc0c923e.png";